export default {
  gardeners_list: (state) => state.gardeners_list,
  gardeners: (state) => state.gardeners,
  gardener_schedule: (state) => state.gardener_schedule,
  gardeners_payment_tracker: (state) => state.gardeners_payment_tracker,
};
